import AreaTemplate from '../AreaTemplate';

const schema = {
  '@context': 'https://schema.org',
  '@type': 'ElectricalContractor',
  name: 'Electrician Solutions Fresno — Clovis',
  description: 'Licensed electrician serving Clovis, CA. C-10 certified electrical contractor for residential and commercial electrical work in Clovis and Fresno County.',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Clovis',
    addressRegion: 'CA',
    postalCode: '93611',
    addressCountry: 'US',
  },
  geo: { '@type': 'GeoCoordinates', latitude: '36.8252', longitude: '-119.7029' },
  url: 'https://electriciansolutionsfresno.com/areas/clovis',
  telephone: '+1-559-123-4567',
  priceRange: '$$',
  areaServed: { '@type': 'City', name: 'Clovis', '@id': 'https://en.wikipedia.org/wiki/Clovis,_California' },
};

const faqs = [
  {
    q: 'Do you provide electrician services in Clovis, CA?',
    a: 'Yes! Electrician Solutions Fresno is the top-rated C-10 licensed electrical contractor serving all of Clovis, CA. From Old Town Clovis to the master-planned communities of northwest Clovis, our certified electricians handle residential panel upgrades, EV charger installations, smart home wiring, and commercial electrical work throughout the Clovis Unified service area.',
  },
  {
    q: 'How quickly can you respond to electrical emergencies in Clovis?',
    a: 'We offer 24/7 emergency electrical services across Clovis with typical response times of 45–90 minutes. Whether you have a tripped breaker, burning smell, or complete power outage in Clovis, our licensed electricians are on call around the clock.',
  },
  {
    q: 'Are Clovis electrical permits required for panel upgrades?',
    a: 'Yes. All panel upgrades in Clovis require permits from the City of Clovis Community Development Department. Electrician Solutions handles all permit applications, inspections, and final sign-offs on your behalf — included in the project price.',
  },
  {
    q: 'Do you install EV chargers in Clovis homes?',
    a: 'Absolutely. We install Level 2 EV chargers (including Tesla Wall Connectors) in Clovis homes and businesses. We handle the 240V circuit installation, permit from the City of Clovis, and PG&E interconnection as needed.',
  },
  {
    q: 'What areas of Clovis do you cover?',
    a: 'We serve all Clovis neighborhoods including Old Town Clovis, Loma Vista, Buchanan High area, Sierra Vista, Harlan Ranch, and Copper River Ranch. We also cover the Clovis Unified School District commercial zone along Herndon and Shaw Avenues.',
  },
  {
    q: 'How much does an electrician cost in Clovis, CA?',
    a: 'Electrical costs in Clovis are similar to Fresno: minor repairs from $150, panel upgrades from $1,500–$4,500, and full rewires from $8,000+. We offer free no-obligation quotes for all Clovis residents and businesses.',
  },
];

const ClovisPage = () => (
  <AreaTemplate
    area="Clovis"
    areaSlug="clovis"
    state="CA"
    county="Fresno County"
    population="120,000+"
    description="Electrician Solutions Fresno is Clovis's premier C-10 licensed electrical contractor. From Old Town Clovis's historic homes to the new master-planned communities along Shepherd and Herndon Avenues, our certified Clovis electricians deliver safe, code-compliant electrical work for homes and businesses throughout Fresno County's fastest-growing city."
    neighborhoods={['Old Town Clovis', 'Loma Vista', 'Harlan Ranch', 'Copper River Ranch', 'Sierra Vista', 'Dry Creek', 'Buchanan Area', 'Clovis Ave Corridor']}
    nearbyAreas={[
      { name: 'Fresno', slug: 'fresno' },
      { name: 'Madera', slug: 'madera' },
      { name: 'Selma', slug: 'selma' },
      { name: 'Sanger', slug: 'sanger' },
      { name: 'Reedley', slug: 'reedley' },
    ]}
    faqs={faqs}
    heroImage="https://public.readdy.ai/ai/img_res/1db9e7c0cccd10321dbc6eb1d19a73a8.jpg"
    heroImageAlt="Licensed Electrician in Clovis CA"
    teamImage="https://readdy.ai/api/search-image?query=Professional%20electrician%20team%20in%20matching%20uniforms%20standing%20confidently%20in%20front%20of%20a%20beautiful%20modern%20Clovis%20California%20suburban%20neighborhood%20with%20manicured%20lawns%20palm%20trees%20clear%20blue%20Central%20Valley%20sky%20showing%20local%20pride%20and%20expertise&width=800&height=600&seq=clovis_team_001&orientation=landscape"
    teamImageAlt="Electrician Solutions team serving Clovis CA"
    schema={schema}
  />
);

export default ClovisPage;
